/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_Col_QtyInputs */

const vi_receipt_col_qty = /** @type {(inputs: Receipt_Col_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SL`)
};

/**

* @param {Receipt_Col_QtyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_col_qty = /** @type {((inputs?: Receipt_Col_QtyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Col_QtyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_col_qty(inputs)
});